(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-app/assets/javascripts/utils/handle-prolong-login.js') >= 0) return;  svs.modules.push('/components/numbergames/game-app/assets/javascripts/utils/handle-prolong-login.js');

'use strict';

function handleProlongLogin() {
  const param = {
    key: 'prolong',
    value: 'login'
  };
  const urlParam = svs.utils.paramHandler.get(param);
  const returnedFromLogin = urlParam.value === param.value;
  if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
    if (returnedFromLogin) {
      svs.utils.url.navigate(svs.core.data.baseUrl);
    } else {
      svs.utils.paramHandler.set(param);
      svs.components.customer_login.login();
    }
    return false;
  }
  if (returnedFromLogin) {
    svs.utils.paramHandler.remove(param);
  }
  return true;
}
svs.numbergames.game_app.utils.handleProlongLogin = handleProlongLogin;

 })(window);